import Text from "component/design-system/typography/Text";
import Link from "next/link";
import { useRouter } from "next/router";
import PageContainer from "../../modules/components/PageContainer";
import AllArticles from "./viewAll-articles";

function Articles(props: any) {
  const router = useRouter();

  function renderSwitch() {
    const { section } = router.query;

    if (props[section]) {
      return (
        <>

          <Text size={3} bold className="p-b-10 p-t-20">
            {props[section].sectionTitle}
          </Text>

          <AllArticles articles={props[section].articles} />
        </>
      );
    }
    return <div />;
  }

  return (
    <PageContainer>

      <Text size={1} bold>
        <Link href="/blog">
          Helpful Automotive Articles
        </Link>
      </Text>
      {renderSwitch()}
    </PageContainer>
  );
}

export default Articles;
